import React from "react";
import PropTypes from "prop-types";
import { CRIT_MIN, META, WARN_MIN } from "./estados";

const Kpi = ({ titulo, dot, valor, valorColor, sub }) => (
  <div className="ms-card ms-kpi">
    <div className="ms-eyebrow">
      {dot && <span className="ms-dot" style={{ background: dot }}></span>}
      {titulo}
    </div>
    <div className="ms-kpi-value" style={valorColor ? { color: valorColor } : undefined}>
      {valor}
    </div>
    <div className="ms-kpi-sub">{sub}</div>
  </div>
);

Kpi.propTypes = {
  titulo: PropTypes.string,
  dot: PropTypes.string,
  valor: PropTypes.number,
  valorColor: PropTypes.string,
  sub: PropTypes.string,
};

const KpiTiles = ({ totals, cnt }) => (
  <>
    <div className="ms-kpis">
      <Kpi
        titulo="Salidas hoy"
        valor={totals.salidas}
        sub={`${totals.curso} en curso · ${totals.fin} finalizadas`}
      />
      <Kpi titulo="Rutas monitoreadas" valor={totals.rutas} sub={`${totals.clientes} clientes`} />
      <Kpi titulo="Al día" dot={META.ok.dot} valor={cnt.ok} sub={`Actualizada hace ≤ ${WARN_MIN} min`} />
      <Kpi
        titulo="Demoradas"
        dot={META.late.dot}
        valor={cnt.late}
        sub={`Entre ${WARN_MIN} y ${CRIT_MIN} min`}
      />
      <Kpi
        titulo="Críticas"
        dot={META.crit.dot}
        valor={cnt.crit}
        valorColor={META.crit.fg}
        sub={`Más de ${CRIT_MIN} min sin datos`}
      />
      <Kpi
        titulo="Sin salidas hoy"
        dot={META.nodata.dot}
        valor={cnt.nodata}
        sub="Rutas sin ninguna salida iniciada"
      />
    </div>
    <p className="ms-note">
      «Última actualización» es el último checkpoint de geocerca registrado para cualquier salida en curso
      de la ruta. Umbrales: demorada &gt; {WARN_MIN} min, crítica &gt; {CRIT_MIN} min.
    </p>
  </>
);

KpiTiles.propTypes = {
  totals: PropTypes.object,
  cnt: PropTypes.object,
};

export default KpiTiles;
